export const crosshairMap = {
	'y': ['primary.type', 1, 4, true],
	'c': ['primary.color', 0, 12, true],
	't': ['primary.thickness', 1, 15, false],
	'l': ['primary.length', 0, 50, false],
	'g': ['primary.gap', 0, 100, false],
	'o': ['primary.opacity', 0, 100, true],
	'0o': ['primary.outlineOpacity', 0, 100, true],
	's': ['primary.size', 2, 10, false],
	'1o': ['primary.dotOpacity', 0, 100, true],
};

const baseParsed = {
	primary: {
		type: 1,
		color: 0,
		thickness: 1,
		length: 25,
		gap: 30,
		opacity: 80,
		outlineOpacity: 50,
		size: 6,
		dotOpacity: 100
	}
};

export const types = ['Default', 'Circle', 'Crosshairs', 'Circle and Crosshairs', 'Dot'];
export const colors = ['#fff', '#0f0', '#0ff', '#f00', '#f0f', '#ff0', '#000', '#ff7000', '#fe6cb7', '#1637ec', '#940cff', '#f9fb9c', '#01881d'];

export const setJsonValue = function(parsed, path, value) {
	const split = path.split('\.');
	var key = parsed;
	for (var i = 0; i < split.length - 1; i++) {
		key = key[split[i]];
	}
	key[split[split.length - 1]] = value;
}

export const getJsonValue = function(parsed, path) {
	try {
		const split = path.split('\.');
		var key = parsed;
		for (var i = 0; i < split.length - 1; i++) {
			key = key[split[i]];
		}
		return key[split[split.length - 1]];
	} catch (error) {
		return undefined;
	}
}

export const getBaseValue = function(path) {
	return getJsonValue(baseParsed, path);
}

const getValue = function(code, keyIndex) {
	if (code.length > keyIndex + 1) {
		const val = parseFloat(code[keyIndex + 1]);
		if (!isNaN(val))
			return val;
	}
	return false;
}

export const validateCrosshair = function(codeInput) {
	codeInput = codeInput.trim();
	if (codeInput === '0')
		return '0';
	if (!/^0;[a-z0-9;.]*$/.test(codeInput))
		return false;
	return codeInput;
}

export const validateCrosshairStrong = function(codeInput) {
	if (!validateCrosshair(codeInput))
		return false;
	try {
		return convertParsedToCode(_parseCrosshair(codeInput));
	} catch (error) {
		return false;
	}
}

export const generateCrosshair = function(codeInput, size=256) {
	try {
		const parsed = parseCrosshair(codeInput);

		const canvas = document.createElement('CANVAS');
		canvas.width = canvas.height = size;

		return renderCrosshair(parsed, canvas);
	} catch (error) {
		console.error(error);
	}
	return false;
}

export const convertParsedToCode = function(parsed) {
	var diff = diffParsed(baseParsed, parsed);

	if (Object.keys(diff).length === 0)
		return '0';

	var code = '0';

	for (var key in crosshairMap) {
		const mapped = crosshairMap[key];
		var value = getJsonValue(diff, mapped[0]);

		if (value === undefined)
			continue;

		if (typeof value === 'boolean')
			value = value ? 1 : 0;

		code += ';' + key + ';' + value;
	}

	return code;
}

const diffParsed = function(baseParsed, parsed) {
	var diff = {};

	for (var key in parsed) {
		const baseValue = baseParsed[key];
		const value = parsed[key];

		if (typeof value === 'object') {
			const recursive = diffParsed(baseValue, value);
			if (Object.keys(recursive).length !== 0) {
				diff[key] = recursive;
			}
		} else if (baseValue !== value) {
			diff[key] = value;
		}
	}

	return diff;
}

export const parseCrosshair = function(codeInput) {
	codeInput = validateCrosshair(codeInput);
	if (!codeInput)
		throw 'This is not a valid crosshair!';

	return _parseCrosshair(codeInput);
}

const _parseCrosshair = function(codeInput) {
	const code = codeInput.split(';');

	var parsed = JSON.parse(JSON.stringify(baseParsed));

	if (code.length <= 1) {
		return parsed;
	}

	const length = code.length;
	for (var off = 1; off < length; off += 2) {
		const val = getValue(code, off);
		if (val === false) {
			console.error('ignoring invalid key: ' + code[off]);
			continue;
		}

		const fullKey = code[off];
		const mapped = crosshairMap[fullKey];
		if (!mapped) {
			console.error('ignoring unmapped key: ' + fullKey);
			continue;
		}

		if (mapped[3] && !Number.isInteger(val)) {
			console.error('ignoring non-int value: ' + fullKey + '=' + val);
			continue;
		}

		if (val < mapped[1] || val > mapped[2]) {
			console.error('ignoring out of bounds value: ' + fullKey + '=' + val);
			continue;
		}

		const split = mapped[0].split('\.');
		var key = parsed;
		for (var i = 0; i < split.length - 1; i++) {
			key = key[split[i]];
		}
		key[split[split.length - 1]] = mapped.length >= 5 ? mapped[4](val) : val;
	}

	return parsed;
}

export const renderCrosshair = function(parsed, canvas) {
	const fullParsed = parsed;
	const ctx = canvas.getContext('2d');
	const mid = canvas.width / 2;
	ctx.imageSmoothingEnabled = false;
	ctx.clearRect(0, 0, canvas.width, canvas.height);

	ctx.lineWidth = 1;

	ctx.globalAlpha = 0.03;
	ctx.strokeStyle = '#000';
	ctx.strokeText('vcrdb.net', 0, canvas.height);

	parsed = parsed.primary;

	const opacity = parsed.opacity / 100;
	const outlineOpacity = parsed.outlineOpacity * 0.006;

	let draws;

	switch (parsed.type) {
		case 1:
			draws = ['circle', 'dot'];
			break;
		case 2:
			draws = ['cross', 'dot'];
			break;
		case 3:
			draws = ['circle', 'cross', 'dot'];
			break;
		case 4:
			draws = ['dot'];
			break;
	}

	for (var i in draws) {
		const drawName = draws[i];

		switch (drawName) {
			case 'dot': {
				ctx.fillStyle = colors[parsed.color];
				ctx.globalAlpha = parsed.dotOpacity / 100;

				ctx.beginPath();
				ctx.arc(mid, mid, parsed.size / 2, 0, 2 * Math.PI);
				ctx.fill();

				ctx.lineWidth = 0.5;
				ctx.strokeStyle = '#000';
				ctx.globalAlpha = parsed.dotOpacity / 100 * outlineOpacity;
				ctx.stroke();
				break;
			}
			case 'circle': {
				const thicknessCapped = Math.min(parsed.thickness, parsed.gap / 4 - 0.5);
				if (thicknessCapped <= 0) {
					break;
				}

				ctx.globalAlpha = opacity;
				ctx.strokeStyle = colors[parsed.color];
				ctx.lineWidth = thicknessCapped * 2;

				ctx.beginPath();
				ctx.arc(mid, mid, parsed.gap / 2 - thicknessCapped, 0, 2 * Math.PI);
				ctx.stroke();

				ctx.lineWidth = 0.5;
				ctx.strokeStyle = '#000';
				ctx.globalAlpha = opacity * outlineOpacity;
				ctx.beginPath();
				ctx.arc(mid, mid, parsed.gap / 2 - thicknessCapped * 2, 0, 2 * Math.PI);
				ctx.stroke();
				ctx.beginPath();
				ctx.arc(mid, mid, parsed.gap / 2, 0, 2 * Math.PI);
				ctx.stroke();
				break;
			}
			case 'cross': {
				let { thickness, length } = parsed;
				var offset = parsed.gap / 2;
				thickness *= 2;

				ctx.fillStyle = colors[parsed.color];
				ctx.strokeStyle = '#000';
				ctx.lineWidth = 0.5;

				// right bottom left top
				fillAndOutline(ctx, mid + offset, mid - thickness / 2, length, thickness, outlineOpacity, opacity);
				fillAndOutline(ctx, mid - thickness / 2, mid + offset, thickness, length, outlineOpacity, opacity);
				fillAndOutline(ctx, mid - offset - length, mid - thickness / 2, length, thickness, outlineOpacity, opacity);
				fillAndOutline(ctx, mid - thickness / 2, mid - offset - length, thickness, length, outlineOpacity, opacity);
				break;
			}
		}
	}

	return canvas;
}

const fillAndOutline = function(ctx, x, y, w, h, outlineOpacity, opacity) {
	ctx.globalAlpha = opacity;
	ctx.fillRect(x, y, w, h);
	ctx.globalAlpha = opacity * outlineOpacity;
	ctx.strokeRect(x - 0.5, y - 0.5, w + 1, h + 1);
}
